import type { Reservation } from '../../../mocks/reservations';

interface Props {
  reservations: Reservation[];
}

export default function StatsCards({ reservations }: Props) {
  const total = reservations.length;
  const beklemede = reservations.filter((r) => r.status === 'beklemede').length;
  const onaylandi = reservations.filter((r) => r.status === 'onaylandi').length;
  const iptal = reservations.filter((r) => r.status === 'iptal').length;

  const totalRevenueTL = reservations
    .filter((r) => r.status !== 'iptal' && r.currency === 'TL')
    .reduce((sum, r) => sum + r.totalPrice, 0);
  const totalRevenueEUR = reservations
    .filter((r) => r.status !== 'iptal' && r.currency === '€')
    .reduce((sum, r) => sum + r.totalPrice, 0);

  const stats = [
    {
      label: 'Toplam Rezervasyon',
      value: total,
      icon: 'ri-calendar-check-line',
      color: 'bg-orange-50 text-orange-500',
      badge: '',
    },
    {
      label: 'Beklemede',
      value: beklemede,
      icon: 'ri-time-line',
      color: 'bg-amber-50 text-amber-500',
      badge: `%${total > 0 ? Math.round((beklemede / total) * 100) : 0}`,
    },
    {
      label: 'Onaylanan',
      value: onaylandi,
      icon: 'ri-checkbox-circle-line',
      color: 'bg-green-50 text-green-500',
      badge: `%${total > 0 ? Math.round((onaylandi / total) * 100) : 0}`,
    },
    {
      label: 'İptal Edilen',
      value: iptal,
      icon: 'ri-close-circle-line',
      color: 'bg-red-50 text-red-400',
      badge: `%${total > 0 ? Math.round((iptal / total) * 100) : 0}`,
    },
  ];

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats.map((s) => (
          <div key={s.label} className="bg-white rounded-xl border border-gray-100 p-5">
            <div className="flex items-start justify-between mb-3">
              <div className={`w-10 h-10 flex items-center justify-center rounded-xl ${s.color}`}>
                <i className={`${s.icon} text-lg`} />
              </div>
              {s.badge && (
                <span className="text-xs font-medium text-gray-400 bg-gray-50 px-2 py-0.5 rounded-full">
                  {s.badge}
                </span>
              )}
            </div>
            <p className="text-2xl font-bold text-gray-900">{s.value}</p>
            <p className="text-xs text-gray-500 mt-0.5">{s.label}</p>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="bg-white rounded-xl border border-gray-100 p-5 flex items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-orange-50 text-orange-500 shrink-0">
            <i className="ri-money-euro-circle-line text-xl" />
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-0.5">Toplam Gelir (Döviz)</p>
            <p className="text-lg font-bold text-gray-900">€{totalRevenueEUR.toLocaleString('tr-TR')}</p>
          </div>
        </div>
        <div className="bg-white rounded-xl border border-gray-100 p-5 flex items-center gap-4">
          <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-amber-50 text-amber-500 shrink-0">
            <i className="ri-bank-card-line text-xl" />
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-0.5">Toplam Gelir (TL)</p>
            <p className="text-lg font-bold text-gray-900">₺{totalRevenueTL.toLocaleString('tr-TR')}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
